export var originalSetTimeout = setTimeout;
export var originalSetInterval = setInterval;
export var originalClearInterval = clearInterval;
export var originalClearTimeout = clearTimeout;


// WEBPACK FOOTER //
// ./src/overrides/override.ts